import React from "react";

import ClickOutsideComp from "react-click-outside";

const isInModal = target => {
  return (
    document.body.className &&
    document.body.className.match("ReactModal__Body--open")
  );
};

class ClickOutside extends React.Component {
  handleClickOutside = e => {
    if (this.props.onClickOutside && !isInModal(e.target)) {
      this.props.onClickOutside(e);
    }
  };

  render() {
    return (
      <ClickOutsideComp onClickOutside={this.handleClickOutside}>
        {this.props.children}
      </ClickOutsideComp>
    );
  }
}

export default ClickOutside;



// WEBPACK FOOTER //
// ./src/utils/ClickOutside.js